import {useMutation, useQueryClient} from '@tanstack/react-query';
import {UseFormReturn} from 'react-hook-form';
import {apiClient} from '@common/http/query-client';
import {toast} from '@common/ui/toast/toast';
import {useTrans} from '@common/i18n/use-trans';
import {onFormQueryError} from '@common/errors/on-form-query-error';
import {message} from '@common/i18n/message';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import { MarketRate } from '@app_modules/market-rates/market-rate';

interface Response extends BackendResponse {
  marketRate: MarketRate;
}

export interface CopyRateSheetPayload {
  source_date: string;
  target_date: string;
}

export function useCopyRateSheet(form: UseFormReturn<CopyRateSheetPayload>) {
  const {trans} = useTrans();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: CopyRateSheetPayload) => copyRateSheet(payload),
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ['billing-transactions']});
      toast(trans(message('Rate Sheet was copied.')));
    },
    onError: err => onFormQueryError(err, form),
  });
}

async function copyRateSheet(payload: CopyRateSheetPayload) {
  return apiClient
    .post<Response>(`market-rates/copy`, payload)
    .then(r => r.data);
}

